module.exports = __webpack_public_path__ + "fonts/righthand-hairline-personal.b59e23fb.ttf";